"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Switch = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledSwitch = require("./StyledSwitch");
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _classnames = _interopRequireDefault(require("classnames"));
var _rcSwitch = _interopRequireDefault(require("rc-switch"));
var _excluded = ["textLabel", "prefixCls", "textLocation", "id"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Text = _Typography.default.Text;
var Switch = exports.Switch = /*#__PURE__*/function (_Component) {
  function Switch() {
    var _this;
    (0, _classCallCheck2.default)(this, Switch);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Switch, [].concat(args));
    (0, _defineProperty2.default)(_this, "inputRef", /*#__PURE__*/(0, _react.createRef)());
    (0, _defineProperty2.default)(_this, "handleChange", function (parameters) {
      _this.inputRef.current.focus();
      var onChange = _this.props.onChange;
      if (onChange && typeof onChange === 'function') {
        onChange(parameters);
      }
    });
    return _this;
  }
  (0, _inherits2.default)(Switch, _Component);
  return (0, _createClass2.default)(Switch, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        textLabel = _this$props.textLabel,
        prefixCls = _this$props.prefixCls,
        textLocation = _this$props.textLocation,
        id = _this$props.id,
        props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var wrapperCls = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-wrapper"), !!prefixCls), "".concat(textLocation), !!prefixCls));
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledSwitch.StyledSwitchWrapper, {
          className: wrapperCls,
          $textLocation: textLocation,
          $size: _this2.props.size
        }, /*#__PURE__*/_react.default.createElement(Text, null, textLabel), /*#__PURE__*/_react.default.createElement(_StyledSwitch.StyledSwitchContainer, {
          theme: theme,
          size: _this2.props.size,
          prefixCls: _this2.props.prefixCls
        }, function (styledPrefix) {
          return /*#__PURE__*/_react.default.createElement(_rcSwitch.default, (0, _extends2.default)({}, props, {
            prefixCls: styledPrefix,
            onChange: _this2.handleChange
          }));
        }), /*#__PURE__*/_react.default.createElement(_StyledSwitch.WidgetIdInput, {
          tabIndex: -1,
          ref: _this2.inputRef,
          id: id
        }));
      });
    }
  }]);
}(_react.Component);
Switch.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  prefixCls: _propTypes.default.string,
  defaultChecked: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  checkedChildren: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),
  size: _propTypes.default.oneOf(['small', 'default', 'large']),
  textLabel: _propTypes.default.string,
  textLocation: _propTypes.default.oneOf(['left', 'right'])
};
Switch.defaultProps = {
  className: '',
  defaultChecked: false,
  disabled: false,
  size: 'default',
  textLocation: 'left'
};
Switch.displayName = 'Switch';
var _default = exports.default = (0, _inputHOC.default)(Switch);